document.addEventListener("DOMContentLoaded", function (e) {
    // Usage of the IoNav
    let ionav = new IoNav({
        // buttonTarget: document.querySelector("#header"),
        buttonElement: document.querySelector(".custom-ionav-btn"),
        elements: ".logo, .nav-main, .quicklinks",
        elementsNav: ".ionav-canvas .ionav-nav-main",
        linkWrapperClass: ".link-wrapper",
        linkSubmenuClickable: true,
        activeClassToggleOthers: true, // Only one active element is possible at the same time
        mqlQuery: {
            minWidth: "0px",
            maxWidth: "1280px",
        },
        debug: false,
    });

    const menuItems = document.querySelectorAll(".nav-main li.has--children");

    function closeItem(el) {
        el.classList.remove("open");
        const btn = el.querySelector("button");
        if (btn) {
            btn.setAttribute("aria-expanded", "false");
        }
    }

    function openItem(el) {
        el.classList.add("open");
        const btn = el.querySelector("button");
        if (btn) {
            btn.setAttribute("aria-expanded", "true");
        }
    }

    menuItems.forEach(function (el) {
        el.addEventListener("mouseenter", function () {
            // Eigenen Timer dieses Elements abbrechen
            clearTimeout(el._menuTimer);
            openItem(el);
        });

        el.addEventListener("mouseleave", function () {
            // Timer am Element selbst speichern, nicht in gemeinsamer Variable
            el._menuTimer = setTimeout(function () {
                closeItem(el);
            }, 100);
        });
    });

    menuItems.forEach(function (el) {
        const btn = el.querySelector("button");
        if (!btn) return;

        btn.addEventListener("click", function () {
            const isOpen = el.classList.toggle("open");
            btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
        });
    });
});
